import { RecordTemplates } from '../modules/records/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { RecordTemplatesView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyRecordTemplatesScreen({
  view,
  onView,
  onOpenThemes,
}: {
  view: RecordTemplatesView;
  onView: ViewSetter<RecordTemplatesView>;
  onOpenThemes: () => void;
}) {
  const { can, timeZone, today } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('records.templates.manage')}>
      <RecordTemplates
        timeZone={timeZone}
        today={today}
        view={view}
        onView={onView}
        onOpenThemes={onOpenThemes}
      />
    </GatedCompanyScreen>
  );
}
